<script>
import { listenToCurrentUserLite } from '../../js/readModel.js';
import { commands } from '../../js/lib/functions.js'
import { showToast } from '../../js/utils/toast.js'
import { hideLoading, showLoading } from '../../js/utils/loading.js';
import { PageShowError, navigate } from '@trullock/page-manager'

export const pageName = 'account-email-verify';
export const pageRoute = '/account/email-verify';
export const title = 'Verify account'
export const requireEmailVerified = false;

export default {
	data() {
		return { 
			currentUser: null,
			ready: false
		}
	},
	methods: {
		async boot(opts) {
			await listenToCurrentUserLite((user, firstCall) => {
				this.currentUser = user;
				if(!firstCall && this.visible && this.currentUser.emailVerified)
				{
					navigate('/');
					
					showToast({
						message: 'Email successfully verfied',
						style: 'bg-success'
					})
				}
			});

			this.ready = true;
		},
		async show(opts)
		{
			if(this.currentUser.emailVerified)
				throw new PageShowError('/', 'Already email verified', {}, 'replace');

			commands.warmUp();

			this.ready = true;
		},
		async resendEmail() {
			showLoading();

			let result = await commands.users.account.requestEmailVerify();
			if(!result.success)
			{
				showToast({ message: 'Error requesting email verification', style: 'bg-danger'})
				hideLoading();
				return;
			}

			showToast({
				message: 'Check your inbox',
				style: 'bg-success'
			})

			hideLoading();
		}
	}
}
</script>
<template>
<div class="container" v-if="ready">
	<div class="row justify-content-center">
		<div class="col-12 col-md-6 my-5">
			<h1 class="display-4 text-center mb-3">Verify your email</h1>
			<p class="text-muted text-center mb-5">Before you continue we need to prove you have access to {{  currentUser.email }}. Check your inbox for an email from UKRA or click the button below to resend it.</p>
			<form ref="form" @submit.prevent="resendEmail">
				<button class="btn btn-block btn-outline-primary" type="submit">Resend email <span class="fe fe-send"></span></button>
			</form>
		</div>
	</div>
</div>
</template>